import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import {
  VolumeInput,
  checkNumeric,
  formatNumber,
  randInt,
  renderFractionUserAnswer,
} from "./PyramidVolumeCommon";

export function generateTask() {
  const baseArea = 3 * randInt(8, 36);
  const h = randInt(4, 18);
  const volume = (baseArea * h) / 3;
  return {
    type: "PyramidVolumeFromBaseAreaTask",
    data: { baseArea, h, volume },
  };
}

export function renderTask({ data }) {
  return (
    <div style={{ textAlign: "left", lineHeight: 1.6 }}>
      <p>Dany jest ostrosłup o polu podstawy i wysokości:</p>
      <BlockMath
        math={`P_p=${data.baseArea}\\,\\text{cm}^2,\\quad H=${data.h}\\,\\text{cm}`}
      />
      <p>Oblicz objętość tego ostrosłupa.</p>
    </div>
  );
}

export function renderInput(_task, userAnswer = {}, onChange, disabled) {
  return (
    <VolumeInput value={userAnswer} onChange={onChange} disabled={disabled} />
  );
}

export function checkAnswer({ data }, userAnswer) {
  return checkNumeric(userAnswer, data.volume);
}

export function renderAnswer({ data }) {
  return <InlineMath math={`V=${formatNumber(data.volume)}\\,\\text{cm}^3`} />;
}

export function renderUserAnswer(userAnswer) {
  return renderFractionUserAnswer(userAnswer, "V", String.raw`\text{cm}^3`);
}

export function renderExplanation({ data }) {
  return (
    <div style={{ textAlign: "left", lineHeight: 1.7 }}>
      <p>
        <strong>Krok 1:</strong> W ostrosłupie objętość jest równa jednej
        trzeciej iloczynu pola podstawy i wysokości.
      </p>
      <BlockMath math={"V=\\frac{1}{3}P_p\\cdot H"} />
      <p>
        <strong>Krok 2:</strong> Podstawiamy dane:
      </p>
      <BlockMath
        math={`V=\\frac{1}{3}\\cdot ${data.baseArea}\\cdot ${data.h}=${formatNumber(
          data.volume
        )}\\,\\text{cm}^3`}
      />
    </div>
  );
}
